import React from 'react';
import { Link } from 'react-router-dom';
import { PackageCheck, RotateCcw, AlertCircle, Mail, ArrowLeft } from 'lucide-react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import SEO from '../common/SEO';
import '../../styles/Home.css';
import '../../styles/Auth.css';

export default function ShippingReturnsPage() {
  return (
    <div className="senritsu-container">
      <SEO
        title="Shipping, Delivery & Cancellation Policy | SenritsuX"
        description="Official Digital Delivery, Shipping, and Cancellation Policy for SenritsuX. Explaining electronic distribution fulfillment and digital beat purchases."
        canonical="/shipping-returns"
        keywords={['SenritsuX shipping policy', 'digital delivery policy', 'refund policy music distribution']}
      />
      <Navbar />

      <main className="page-main-content">
        <section className="about-hero-section" style={{ paddingTop: '2.5rem', paddingBottom: '1.5rem' }}>
          <div className="about-hero-wrapper" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <span className="page-badge">Compliance &amp; Operations</span>
            <h1 className="about-hero-title" style={{ fontSize: '2.4rem', marginTop: '0.5rem' }}>
              Shipping, Delivery &amp; <span className="title-highlight">Cancellation Policy</span>
            </h1>
            <p className="about-hero-subtitle" style={{ margin: '0 auto 1.5rem', maxWidth: '600px' }}>
              Last Updated: January 2025 • Effective for all digital services, subscriptions, and marketplace purchases.
            </p>
          </div>
        </section>

        <div style={{ maxWidth: '850px', margin: '0 auto 4rem', padding: '0 1.5rem' }}>
          <div
            className="auth-card"
            style={{
              padding: '2.5rem',
              borderRadius: '16px',
              lineHeight: 1.8,
              color: 'rgba(255,255,255,0.85)',
              fontSize: '0.98rem',
            }}
          >
            {/* Section 1: Digital Delivery */}
            <div style={{ marginBottom: '2.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem' }}>
                <PackageCheck size={22} color="#d9fb06" />
                <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#fff', margin: 0 }}>
                  1. Nature of Digital Goods &amp; Instant Delivery
                </h2>
              </div>
              <p>
                SenritsuX (accessible at <strong style={{ color: '#fff' }}>https://senritsux.in</strong>) provides electronic services, including digital music distribution to global Digital Service Providers (DSPs), digital beat licenses, audio master file delivery, and promotional tools.
              </p>
              <p>
                Because all items and services provided on SenritsuX are digital:
              </p>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: '1rem' }}>
                <li><strong>No Physical Shipping:</strong> No tangible physical merchandise or physical compact discs are shipped to physical addresses.</li>
                <li><strong>Delivery Timeline for Beats:</strong> Digital audio files (WAV, MP3, stems) and digital license certificates are delivered electronically and instantly upon verified payment confirmation.</li>
                <li><strong>Delivery Timeline for Music Distribution:</strong> Music releases are ingested into our quality control system immediately upon submission. DSP delivery takes between 24 hours to 5 business days depending on the selected plan.</li>
              </ul>
            </div>

            {/* Section 2: Cancellation & Refund Policy */}
            <div style={{ marginBottom: '2.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem' }}>
                <RotateCcw size={22} color="#d9fb06" />
                <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#fff', margin: 0 }}>
                  2. Refund &amp; Cancellation Policy
                </h2>
              </div>
              <p>
                Due to the immediate, non-returnable nature of downloadable digital files and irreversible DSP ingestion processes:
              </p>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: '1rem' }}>
                <li><strong>Digital Beat Licenses:</strong> Once an untagged audio file or stem package has been downloaded or license keys generated, payments are non-refundable.</li>
                <li><strong>Music Distribution Submissions:</strong> Cancellation requests submitted prior to quality review ingestion (within 2 hours of payment) may be eligible for a full credit refund. Once audio files are delivered to DSP servers (Spotify, Apple Music, etc.), ingestion fees cannot be refunded.</li>
                <li><strong>Duplicate / Accidental Transactions:</strong> If an error occurs resulting in duplicate billing by our payment gateway, the excess charge will be refunded in full to the original payment method within 5 to 7 business days.</li>
              </ul>
            </div>

            {/* Section 3: Defective Files or Technical Issues */}
            <div style={{ marginBottom: '2.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem' }}>
                <AlertCircle size={22} color="#d9fb06" />
                <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#fff', margin: 0 }}>
                  3. Damaged or Corrupted File Resolution
                </h2>
              </div>
              <p>
                If you encounter any corrupted download links, missing stem stems, or technical fulfillment glitches, contact our support team within 48 hours of purchase. We will verify the transaction and regenerate replacement download links immediately at zero additional fee.
              </p>
            </div>

            {/* Section 4: Contact & Grievance */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem' }}>
                <Mail size={22} color="#d9fb06" />
                <h2 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#fff', margin: 0 }}>
                  4. Support &amp; Grievance Redressal
                </h2>
              </div>
              <p>
                For all delivery queries, transaction verifications, or refund disputes, please reach out directly:
              </p>
              <div style={{ background: 'rgba(255,255,255,0.06)', padding: '1rem 1.2rem', borderRadius: '10px', marginTop: '0.8rem' }}>
                <p style={{ margin: '0 0 0.4rem' }}><strong>Email Support:</strong> <a href="mailto:support@senritsux.in" style={{ color: '#d9fb06' }}>support@senritsux.in</a></p>
                <p style={{ margin: 0 }}><strong>Response SLA:</strong> Within 24 to 48 business hours.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
